<template>
  <v-row justify="center">
    <v-dialog
      v-model="show"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title> {{ order.name }} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn
              dark
              text
              @click="submit"
              :loading="loading"
              :disabled="step != 2"
              >Toevoegen</v-btn
            > -->
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
          <v-card :loading="loading.init">
            <v-card-title>{{ formattedDate }}</v-card-title>
            <v-card-text>
              <v-simple-table v-if="!editMode">
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td>{{ item.amount }}</td>
                    <td>{{ item.product }}</td>
                    <td>{{ item.size }}</td>
                    <td>{{ item.pack }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-expansion-panels focusable v-else>
                <v-expansion-panel v-for="item in items" :key="item.id">
                  <v-expansion-panel-header @click="selectedItem = item"
                    >{{ item.amount }} {{ item.product }} {{ item.size }}
                    {{ item.pack }}</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <v-text-field v-model="selectedItem.amount"></v-text-field>
                    <v-text-field v-model="selectedItem.product"></v-text-field>
                    <v-text-field v-model="selectedItem.size"></v-text-field>
                    <v-text-field v-model="selectedItem.pack"></v-text-field>
                    <v-btn text @click="saveSelected" :loading="loading.edit"
                      >Opslaan</v-btn
                    >
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels></v-card-text
            >
            <v-divider v-show="order.note != ''"></v-divider>
            <p>{{ order.note }}</p>
            <v-card-actions
              ><v-spacer></v-spacer>
              <v-btn text @click="dialogs.delete = true"
                >Verwijderen</v-btn
              ></v-card-actions
            >

            <v-btn
              fab
              right
              fixed
              bottom
              offset
              v-show="!editMode && order.accepted"
              color="blue"
              class="white--text"
              @click="editMode = true"
              ><v-icon>mdi-pencil-outline</v-icon></v-btn
            ></v-card
          >
        </v-container>
        <v-btn
          v-if="!order.accepted"
          @click="accept"
          fab
          bottom
          right
          fixed
          color="green"
          class="white--text mb-8 mr-4"
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>
    <Confirmation
      question="Bestelling verwijderen?"
      subtext="Deze actie is onomkeerbaar"
      :visible="dialogs.delete"
      @close="dialogs.delete = false"
      @confirm="deleteOrder"
    />
    <v-snackbar v-model="accepted"> Bestelling geaccepteerd </v-snackbar>
  </v-row>
</template>

<script>
import { firestore } from "firebase";
import moment from "moment";
import Confirmation from "@/components/Confirmation";
export default {
  props: {
    visible: {
      type: Boolean,
      require: true,
    },
    order: {
      type: Object,
    },
  },
  components: {
    Confirmation,
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    formattedDate() {
      return moment(this.order.saleDate, "YYYY-MM-DD")
        .lang("nl")
        .format("dddd D MMMM");
    },
  },
  data() {
    return {
      editMode: false,
      accepted: false,
      items: [],
      selectedItem: {},
      dialogs: {
        delete: false,
      },
      loading: {
        edit: false,
        init: false,
      },
    };
  },
  watch: {
    order() {
      this.fetchOrder();
    },
  },
  methods: {
    async deleteOrder() {
      await firestore().collection("Orders").doc(this.order.id).delete();
      this.dialogs.delete = false;
      this.show = false;
      this.$emit("refresh");
    },
    async saveSelected() {
      this.loading.edit = true;
      let id = this.selectedItem.id;
      delete this.selectedItem.id;
      await firestore()
        .collection("Orders/" + id + "/items/")
        .doc(id)
        .set(this.selectedItem);
      let c = 0;
      for (var i = 0; i <= this.items.length - 1; i++) {
        if (this.items[c].id == id) {
          c += parseInt(this.selectedItem.amount);
        } else {
          c += this.items[c].amount;
        }
      }
      await firestore()
        .collection("Orders")
        .doc(this.order.id)
        .update({
          box_amount: parseInt(c),
        });
      this.loading.edit = false;
      this.editMode = false;
    },
    async fetchOrder() {
      this.loading.init = true;
      if (!this.order) return;
      let _self = this;
      let items = await firestore()
        .collection("Orders/" + this.order.id + "/items")
        .get();
      _self.items = [];
      items.forEach((item) => {
        _self.items.push({
          id: item.id,
          ...item.data(),
        });
      });
      this.loading.init = false;
    },
    async accept() {
      await firestore().collection("Orders").doc(this.order.id).update({
        accepted: true,
      });
      this.accepted = true;
      this.order.accepted = true;
    },
  },
};
</script>

<style>
</style>